const handle = "dancasttro"

const links = [
  {
    label: "Github",
    url: `https://github.com/${handle}`,
  },
  {
    label: "Linkedin",
    url: `https://www.linkedin.com/in/${handle}`,
  },
  {
    label: "Codepen",
    url: `https://codepen.io/${handle}`,
  },
  {
    label: "Twitter",
    url: `https://twitter.com/${handle}`,
  },
]

export default links
